import { isMobile as checkMobile } from './index';
import { fireEvent } from './index';
export var ESwipeGesture;
(function (ESwipeGesture) {
    ESwipeGesture["SWIPE_RIGHT"] = "swipe-right";
    ESwipeGesture["SWIPE_LEFT"] = "swipe-left";
    ESwipeGesture["SWIPE_UP"] = "swipe-up";
    ESwipeGesture["SWIPE_DOWN"] = "swipe-down";
    ESwipeGesture["SWIPE_START"] = "swipe-start";
    ESwipeGesture["SWIPE_SHORT"] = "swipe-short";
    ESwipeGesture["SWIPE_CANCEL"] = "swipe-cancel";
    ESwipeGesture["SWIPE_MOVE_X"] = "swipe-move-x";
    ESwipeGesture["SWIPE_MOVE_Y"] = "swipe-move-y";
})(ESwipeGesture || (ESwipeGesture = {}));
const defaultSwipePoint = () => ({ x: 0, y: 0, px: 0, py: 0 });
function SwipeAdapter(elem, opts) {
    const isMobile = checkMobile();
    const targetElement = elem;
    const startEvent = isMobile ? 'touchstart' : 'mousedown';
    const moveEvent = isMobile ? 'touchmove' : 'mousemove';
    const endEvent = isMobile ? 'touchend' : 'mouseup';
    const min_gesture_length = (opts === null || opts === void 0 ? void 0 : opts.gestureMinLength) || 20;
    const tolerance = 0.3;
    let active = false;
    let currentEvent = null;
    let startPoint = defaultSwipePoint();
    let endPoint = defaultSwipePoint();
    let prevPoint = defaultSwipePoint();
    const touchHandlers = {
        [startEvent](e) {
            const touch = ('touches' in e) ? e.touches[0] : e;
            currentEvent = e;
            startPoint = { x: touch.screenX, y: touch.screenY, px: touch.pageX, py: touch.pageY };
            endPoint = { ...startPoint };
            prevPoint = { ...endPoint };
            active = true;
            fireEvent(e, ESwipeGesture.SWIPE_START);
        },
        [moveEvent](e) {
            if (!active)
                return;
            if ('touches' in e && e.touches.length > 1) {
                active = false;
                return;
            }
            currentEvent = e;
            const touch = ('touches' in e) ? e.touches[0] : e;
            prevPoint = { ...endPoint };
            endPoint = { x: touch.screenX, y: touch.screenY, px: touch.pageX, py: touch.pageY };
            const dx = Math.abs(endPoint.x - startPoint.x);
            const dy = Math.abs(endPoint.y - startPoint.y);
            if (dy > dx && dx / dy < tolerance) {
                fireEvent(e, ESwipeGesture.SWIPE_MOVE_Y);
            }
            else if (dx > dy && dy / dx < tolerance) {
                fireEvent(e, ESwipeGesture.SWIPE_MOVE_X);
            }
        },
        [endEvent](e) {
            if (!active)
                return;
            active = false;
            currentEvent = e;
            const dx = Math.abs(endPoint.x - startPoint.x);
            const dy = Math.abs(endPoint.y - startPoint.y);
            let eventName = ESwipeGesture.SWIPE_SHORT;
            if (Math.max(dx, dy) < min_gesture_length) {
                fireEvent(e, eventName);
                return;
            }
            if (dy > dx && dx / dy < tolerance && Math.abs(startPoint.py - endPoint.py) > min_gesture_length) {
                eventName = endPoint.y - startPoint.y < 0 ? ESwipeGesture.SWIPE_UP : ESwipeGesture.SWIPE_DOWN;
            }
            else if (dx > dy && dy / dx < tolerance && Math.abs(startPoint.px - endPoint.px) > min_gesture_length) {
                eventName = endPoint.x - startPoint.x < 0 ? ESwipeGesture.SWIPE_LEFT : ESwipeGesture.SWIPE_RIGHT;
            }
            fireEvent(e, eventName);
        },
        touchcancel(e) {
            active = false;
            fireEvent(e, ESwipeGesture.SWIPE_CANCEL);
        }
    };
    const gestureHandlers = {};
    return {
        init() {
            for (var a in touchHandlers) {
                targetElement.addEventListener(a, touchHandlers[a], false);
            }
        },
        destroy() {
            for (var a in touchHandlers) {
                targetElement.removeEventListener(a, touchHandlers[a]);
            }
        },
        onSwipe(gesture, cb) {
            gestureHandlers[gesture] = () => cb({
                event: currentEvent,
                startPoint: { ...startPoint },
                endPoint: { ...endPoint },
                prevPoint: { ...prevPoint }
            });
            targetElement.addEventListener(gesture, gestureHandlers[gesture]);
        },
        offSwipe(gesture) {
            targetElement.removeEventListener(gesture, gestureHandlers[gesture]);
            delete gestureHandlers[gesture];
        },
        offSwipeAll() {
            for (let gesture in gestureHandlers) {
                targetElement.removeEventListener(gesture, gestureHandlers[gesture]);
                delete gestureHandlers[gesture];
            }
        }
    };
}
export default SwipeAdapter;
